import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { createClient } from 'contentful';
import { Typography, Button } from '@telus-uds/components-web';

import RichText from '../../richText';
import request, { emergencyFormsUrl } from '../../utils/request';
import { getCfConfig } from '../../contentful';
import {
  CONSTANT,
  ALL_USERS,
  INTERNAL_USERS,
  EXTERNAL_USERS
} from '../../utils/constant';

const EmergencyForms = ({ locale }) => {
  const {
    KEYS: {
      CHANNELS: { DEALER }
    }
  } = CONSTANT;
  const [emergencyForms, setEmergencyForms] = useState([]);

  const navigateToEmergencyFrom = formUrl => {
    const accessToken = request.getToken();
    const encodedData = encodeURIComponent(
      JSON.stringify({ token: accessToken, platform: 'sof1' })
    );

    window.open(
      `${emergencyFormsUrl}/${locale}${formUrl}?key=${encodedData}`,
      '_blank'
    );
  };

  useEffect(() => {
    (async () => {
      try {
        const { emergencyForms: emergencyFormsConfig } = await getCfConfig();
        const client = createClient({
          ...emergencyFormsConfig
        });

        const result = await client.getEntries({
          include: 8,
          limit: 1000,
          content_type: 'page',
          locale
        });
        if (result) {
          const { items } = result;
          const { channelName } = request.getProfile();
          const filteredforms = items.filter(
            ({ fields: { visibility } }) =>
              (visibility === EXTERNAL_USERS && channelName === DEALER) ||
              (visibility === INTERNAL_USERS && channelName !== DEALER) ||
              visibility === ALL_USERS
          );
          setEmergencyForms(filteredforms);
        }
      } catch (e) {
        console.log(e.message);
      }
    })();
  }, []);
  return (
    <>
      {emergencyForms.length > 0 && (
        <>
          {emergencyForms.map(
            ({ fields: { pageTitle, pageDescription, pageUrl } }) => (
              <div className="category-card">
                <div className="category-card__inner">
                  <div className="category-card__header">
                    <Typography heading="h3" variant={{ size: 'h3' }} block><span style={{fontWeight: 500}}>{pageTitle}</span></Typography>
                    <Typography variant={{ size: 'large' }}>
                      <RichText data={pageDescription} />
                    </Typography>
                  </div>
                  <div className="category-card__forms">
                    <Button
                      variant={{ priority: 'low' }}
                      onPress={() => navigateToEmergencyFrom(pageUrl)}
                    >
                      Access Now
                    </Button>
                  </div>
                </div>
              </div>
            )
          )}
        </>
      )}
    </>
  );
};

EmergencyForms.propTypes = {
  locale: PropTypes.string.isRequired
};

export default EmergencyForms;
